import React from 'react';
import './FormTag.css'; // optional external styling

const FormTag = ({ label, onRemove }) => {
  return (
    <div className="tag">
      <span className="tag-label">{label}</span>
      <button className="tag-close" onClick={()=>onRemove(label)}>&times;</button>
    </div>
  );
};

export default FormTag;
